import { Link } from "react-router-dom";
import { ArrowRight, HandHeart, Sparkle, ShieldCheck, Users } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";

const VALUES = [
  { icon: HandHeart, title: "Care first, always", body: "We measure success by how our patients feel — before we look at any numbers." },
  { icon: ShieldCheck, title: "Evidence & ethics", body: "Every treatment protocol is peer-reviewed. Every conversation is honest." },
  { icon: Users, title: "Family in every room", body: "You are never alone. We build teams around you, not schedules." },
  { icon: Sparkle, title: "Quietly excellent", body: "No jargon. No fear-selling. Just careful, thorough, exceptional medicine." },
];

export default function About() {
  return (
    <div data-testid="about-page">
      <section className="max-w-7xl mx-auto px-6 lg:px-10 py-20 grid lg:grid-cols-12 gap-14 items-center">
        <div className="lg:col-span-6">
          <div className="text-xs uppercase tracking-[0.28em] text-brand-sage mb-5">About Jashoda Hospital</div>
          <h1 className="font-serif text-5xl sm:text-6xl tracking-tight leading-[1.02]">
            A hospital designed around <em className="italic text-brand-sage not-italic">people</em>, not paperwork.
          </h1>
          <p className="mt-7 text-lg text-brand-muted leading-relaxed">
            Founded in 1998 by a small group of physicians who believed healthcare had lost its warmth,
            Jashoda Hospital has grown into one of the region's most trusted multi-specialty hospitals — without losing what made us start.
          </p>
          <p className="mt-4 text-lg text-brand-muted leading-relaxed">
            Today we welcome over 40,000 families a year. We still answer the phone by the third ring.
          </p>
          <div className="mt-9">
            <Link to="/book"><Button data-testid="about-book-btn" className="rounded-full bg-[#C85A40] hover:bg-[#A94A32] text-white h-13 px-8">Book a visit <ArrowRight size={18} className="ml-2" /></Button></Link>
          </div>
        </div>
        <div className="lg:col-span-6">
          <img
            src="/images/about-hospital.jpg"
            alt="Jashoda Hospital building"
            className="rounded-[2rem] w-full h-[540px] object-cover border border-brand-border"
          />
        </div>
      </section>

      <section className="bg-[#F0EEE6] border-y border-brand-border py-24" data-testid="about-values">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <div className="max-w-2xl mb-14">
            <div className="text-xs uppercase tracking-[0.28em] text-brand-sage mb-4">What we stand for</div>
            <h2 className="font-serif text-4xl sm:text-5xl tracking-tight leading-[1.05]">Four ideas that guide every decision.</h2>
          </div>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {VALUES.map((v) => (
              <div key={v.title} className="bg-white rounded-3xl border border-brand-border p-7">
                <div className="w-12 h-12 rounded-full bg-[#E8ECE4] flex items-center justify-center mb-5">
                  <v.icon size={22} className="text-brand-sage" />
                </div>
                <div className="font-serif text-xl leading-tight">{v.title}</div>
                <p className="text-sm text-brand-muted mt-3 leading-relaxed">{v.body}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="max-w-4xl mx-auto px-6 py-24 text-center">
        <blockquote className="font-serif italic text-3xl sm:text-4xl leading-[1.25] text-brand-ink">
          "A hospital is not a place. It is a promise — that when you walk in scared, you'll walk out heard."
        </blockquote>
        <div className="mt-8 text-sm text-brand-muted uppercase tracking-wider">— Dr. R. Malhotra, Founding Chairperson</div>
      </section>
    </div>
  );
}